export default __webpack_public_path__ + "static/media/p5.e9582a48.jpeg";